<template>
  <v-card>
    <v-card-title class="headline">{{title}}</v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-text-field label="Nazwa" v-model="nazwa" :rules="[v=> !!v || 'Proszę podać nazwę.']"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <p>Opis:</p>
              <tiptap-vuetify v-model="opis" name="opis"
                              :extensions="extensions"
                              :toolbar-attributes="{ color: 'primary' }"
                              placeholder="Wprowadź opis problemu..."
                              class="tiptap-editor-large" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-menu
                  v-model="open_date"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="data"
                      label="Data wystąpienia problemu"
                      prepend-icon="fa-calendar-alt"
                      readonly
                      :rules="[v=> !!v || 'Proszę podać datę problemu.']"
                      clearable
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="data"
                    @input="open_date = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save()" color="success">Zapisz</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="closeForm()" color="error">Zamknij</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {clientService} from "@/services";
import swal from "sweetalert";
import dayjs from "dayjs";
import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Blockquote, HardBreak, History } from 'tiptap-vuetify'

export default {
  name: "ProblemEdit",
  components: { TiptapVuetify },
  props: ["id","client"],
  data() {
    return {
      valid: true,
      loading: false,
      nazwa: null,
      opis: null,
      data: null,
      open_date: false,
      title: 'Dodawanie problemu',
      extensions: [
        History,
        Blockquote,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [Heading, {
          options: {
            levels: [1, 2, 3]
          }
        }],
        Bold,
        Code,
        HardBreak,
        Paragraph
      ]
    }
  },
  methods: {
    save()
    {
      if(this.$refs.form.validate()) {
        // Validate tiptap content
        if(!this.opis || this.opis.trim() === '' || this.opis === '<p></p>') {
          this.showError('Proszę podać opis.')
          return
        }

        if(!this.id || this.id <= 0) {
          clientService.insertProblem({
            clientid: this.client,
            nazwa: this.nazwa,
            opis: this.opis,
            data: this.data
          }).then(() => {
            this.closeForm()
          }).catch(() => {
            this.showError('Błąd zapisu problemu')
          })
        }
        else
        {
          clientService.editProblem({
            id: this.id,
            clientid: this.client,
            nazwa: this.nazwa,
            opis: this.opis,
            data: this.data
          }).then(()=> {
            this.closeForm()
          }).catch(() => {
            this.showError('Błąd zapisu problemu')
          })
        }
      }
    },
    getData()
    {
      this.loading = true
      clientService.getProblem(this.id).then(result => {
        let prb = result.data.result
        this.nazwa = prb.nazwa
        this.opis = prb.opis
        this.data = dayjs(prb.problem_data).format("YYYY-MM-DD")
      }).catch(() => {
        this.showError('Błąd pobrania problemu')
      })
    },
    closeForm() {
      this.$emit('close')
    },
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false;
      });
    },
  },
  watch: {
    id: {
      immediate: true,
      handler(val) {
        if (val != null && val > 0) {
          this.title = 'Edycja problemu'
          this.getData()
        }
      }
    }
  }
}
</script>

<style scoped>
.tiptap-editor-large >>> .ProseMirror {
  min-height: 300px;
  max-height: 500px;
  overflow-y: auto;
}
</style>